import React, {Component, Children, cloneElement, isValidElement} from 'react'
import propTypes from 'prop-types'
import {isNil} from 'lodash'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import Icon, {iconNames} from 'components/icon'
import {getSubMenuLeft} from 'helpers/ui'

export const SubMenuArrow = () => (
  <span style={{marginLeft: 'auto', paddingLeft: 24, display: 'inline-flex'}}>
    <Icon name={iconNames.dropright}/>
  </span>
)

class SubMenuItem extends Component {
  state = {
    anchorEl: null,
  }

  onOpen = (e) => {
    e.preventDefault()
    e.stopPropagation()
    this.setState({anchorEl: e.currentTarget})
  }

  onClose = () => this.setState({anchorEl: null})

  onEntering = (element) => {
    const {anchorEl} = this.state
    if (!anchorEl) return

    const width = element.offsetWidth
    const left = getSubMenuLeft(anchorEl.getBoundingClientRect(), width)

    if (isNil(left)) return

    const originY = element.style.transformOrigin.split(' ')[1] || 'top'

    element.style.left = `${left}px`
    element.style.transformOrigin = `${width}px ${originY}`
  }

  closeOnLeafClick = (child) => {
    if (!isValidElement(child)) return child
    if (child.type === SubMenuItem) return child

    return cloneElement(child, {
      onClick: (e) => {
        if (child.props.onClick) child.props.onClick(e)
        this.onClose()
      },
    })
  }

  render() {
    const {label, icon, className, disabled, children, ...other} = this.props
    const {anchorEl} = this.state

    return [
      <MenuItem
        {...other}
        key={'sub-menu-item'}
        className={className}
        disabled={disabled}
        onClick={this.onOpen}
      >
        {icon ? <ListItemIcon>{icon}</ListItemIcon> : null}
        <span>{label}</span>
        <SubMenuArrow/>
      </MenuItem>,
      <Menu
        key={'sub-menu'}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{horizontal: 'right', vertical: 'top'}}
        transformOrigin={{horizontal: 'left', vertical: 'top'}}
        onClose={this.onClose}
        onEntering={this.onEntering}
        onClick={(e) => e.stopPropagation()}
        disableRestoreFocus={true}>
        {Children.map(children, this.closeOnLeafClick)}
      </Menu>,
    ]
  }
}

SubMenuItem.propTypes = {
  label: propTypes.node.isRequired,
  icon: propTypes.element,
  className: propTypes.string,
  disabled: propTypes.bool,
  children: propTypes.node,
}

export default SubMenuItem
